import React, { useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';


const Carousel = () => {
  const carouselRef = useRef(null);
  const intervalRef = useRef(null);

 
  const showNextSlide = useCallback(() => {
    if (carouselRef.current) {
      const nextButton = carouselRef.current.querySelector('.carousel-control-next');
      nextButton.click(); 
    }
  }, []);

 
  const startCarousel = () => {
    stopCarousel(); // 
    intervalRef.current = setTimeout(() => {
      showNextSlide();
      startCarousel(); 
    }, 5000); 
  };

  const stopCarousel = () => {
    if (intervalRef.current) {
      clearTimeout(intervalRef.current);
      intervalRef.current = null; 
    }
  };

  useEffect(() => {
    startCarousel(); 

    return () => stopCarousel(); 
  }, []);

  const handleSlide = () => {
    stopCarousel(); 
    startCarousel(); 
  };

  return (
    <div 
      id="carouselExampleAutoplay" 
      className="carousel slide" 
      data-bs-ride="false" 
      data-bs-interval="false" 
      ref={carouselRef}
      onMouseEnter={stopCarousel} 
      onMouseLeave={startCarousel} >

      <div className="carousel-inner">
        <div className="carousel-item active" onClick={handleSlide}>
          <img src="./images/sliderlocal.jpg" className="d-block w-100" alt="Slider local" />
        </div>
        <div className="carousel-item" onClick={handleSlide}>
          <img src="./images/slider-local-matriz.jpeg" className="d-block w-100" alt="Local matriz" />
        </div>
        <div className="carousel-item" onClick={handleSlide}>
          <img src="./images/slider-local-sigsal.png" className="d-block w-100" alt="Local matriz" />
        </div>
        <div className="carousel-item" onClick={handleSlide}>
          <img src="./images/slider-local-tabacundo.png" className="d-block w-100" alt="Local sigsal" />
        </div>
        <div className="carousel-item" onClick={handleSlide}>
          <img src="./images/slider-conductores.png" className="d-block w-100" alt="Slider tabacundo" />
        </div>
      </div>
      <a className="carousel-control-prev" href="#carouselExampleAutoplay" role="button" data-bs-slide="prev" onClick={handleSlide}>
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Anterior</span>
      </a>
      <a className="carousel-control-next" href="#carouselExampleAutoplay" role="button" data-bs-slide="next" onClick={handleSlide}>
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Siguiente</span>
      </a>
    </div>
  );
};

export default Carousel;